import React from "react";

const Viber = () => {
  return (
    <svg
      x="0px"
      y="0px"
      width="566.93px"
      height="566.93px"
      viewBox="0 0 566.93 566.93"
      enableBackground="new 0 0 566.93 566.93"
    >
      <path
        fill="#606060"
        d="M544.785,136.958l-0.17-0.646C531.443,82.93,472.064,25.661,417.527,13.74l-0.611-0.122
	c-88.207-16.871-177.648-16.871-265.839,0l-0.626,0.122C95.932,25.661,36.553,82.93,23.363,136.312l-0.152,0.646
	c-16.282,74.547-16.282,150.137,0,224.675l0.152,0.655c12.625,51.097,67.587,105.737,120.081,120.765v59.58
	c0,21.564,26.222,32.156,41.127,16.595l60.227-62.749c13.057,0.734,26.134,1.143,39.2,1.143c44.404,0,88.824-4.208,132.918-12.639
	l0.611-0.131c54.537-11.911,113.916-69.19,127.088-122.563l0.17-0.655C561.067,287.095,561.067,211.505,544.785,136.958
	L544.785,136.958z M497.119,350.822c-8.789,34.819-53.883,78.115-89.709,86.111c-46.894,8.943-94.169,12.761-141.391,11.451
	c-0.936-0.027-1.848,0.336-2.501,1.018c-6.697,6.89-43.97,45.243-43.97,45.243l-46.772,48.113c-3.42,3.577-9.427,1.143-9.427-3.79
	v-98.696c0-1.63-1.165-3.02-2.757-3.33l-0.034-0.009c-35.826-7.996-80.892-51.292-89.699-86.111
	c-14.658-67.374-14.658-135.678,0-203.052c8.807-34.819,53.874-78.115,89.699-86.111c81.917-15.622,164.962-15.622,246.852,0
	c35.844,7.996,80.92,51.292,89.709,86.111C511.796,215.144,511.796,283.448,497.119,350.822L497.119,350.822z"
      />
      <path
        fill="#606060"
        d="M361.93,396.382c-5.514-1.673-10.761-2.797-15.628-4.827c-50.518-21.004-96.998-48.102-133.821-89.645
	c-20.939-23.625-37.327-50.29-51.189-78.521c-6.563-13.382-12.102-27.293-17.75-41.108c-5.141-12.602,2.44-25.62,10.417-35.112
	c7.491-8.909,17.13-15.729,27.563-20.759c8.147-3.922,16.178-1.655,22.133,5.262c12.862,14.965,24.675,30.693,34.233,48.032
	c5.885,10.671,4.277,23.706-6.387,30.968c-2.587,1.764-4.955,3.836-7.369,5.829c-2.11,1.752-4.107,3.514-5.557,5.878
	c-2.651,4.332-2.782,9.433-1.068,14.135c13.145,36.218,35.303,64.379,71.667,79.541c5.822,2.426,11.661,5.25,18.367,4.471
	c11.229-1.319,14.859-13.654,22.732-20.111c7.685-6.296,17.51-6.384,25.797-1.124c8.287,5.253,16.318,10.893,24.295,16.597
	c7.837,5.595,15.637,11.068,22.866,17.454c6.953,6.137,9.348,14.187,5.433,22.509c-7.165,15.25-17.589,27.932-32.627,36.035
	C371.789,394.17,366.718,394.904,361.93,396.382C356.416,394.709,366.718,394.904,361.93,396.382L361.93,396.382z"
      />
      <path
        fill="#606060"
        d="M284.138,108.974c66.067,1.859,120.332,45.81,131.957,111.28c1.979,11.158,2.687,22.564,3.569,33.881
	c0.371,4.765-2.314,9.29-7.448,9.352c-5.29,0.063-7.676-4.373-8.02-9.138c-0.681-9.422-1.149-18.889-2.449-28.231
	c-6.837-49.335-46.082-90.151-95.071-98.909c-7.375-1.319-14.921-1.664-22.386-2.453c-4.718-0.497-10.901-0.78-11.944-6.661
	c-0.884-4.931,3.268-8.855,7.959-9.111C281.578,108.913,282.858,108.974,284.138,108.974
	C350.205,110.833,282.858,108.974,284.138,108.974L284.138,108.974z"
      />
      <path
        fill="#606060"
        d="M384.538,239.444c-0.106,0.823-0.167,2.77-0.645,4.604c-1.757,6.642-11.813,7.474-14.127,0.771
	c-0.69-1.993-0.787-4.26-0.796-6.402c-0.018-14.028-3.065-28.039-10.114-40.24c-7.262-12.548-18.342-23.097-31.338-29.471
	c-7.862-3.861-16.361-6.252-24.976-7.688c-3.764-0.619-7.57-1-11.352-1.533c-4.587-0.637-7.034-3.559-6.821-8.093
	c0.204-4.242,3.295-7.298,7.916-7.032c15.16,0.859,29.809,4.146,43.282,11.301c27.414,14.55,43.07,37.522,47.645,68.188
	c0.204,1.39,0.538,2.764,0.645,4.162C384.115,231.455,384.273,234.901,384.538,239.444
	C384.432,240.267,384.273,234.901,384.538,239.444L384.538,239.444z"
      />
      <path
        fill="#606060"
        d="M343.447,237.842c-5.53,0.097-8.49-2.968-9.056-8.05c-0.398-3.543-0.706-7.13-1.554-10.573
	c-1.662-6.792-5.259-13.081-10.956-17.243c-2.687-1.956-5.733-3.391-8.922-4.312c-4.055-1.177-8.271-0.85-12.317-1.85
	c-4.39-1.072-6.819-4.641-6.132-8.776c0.629-3.756,4.277-6.688,8.377-6.395c25.612,1.852,43.925,15.126,46.532,45.359
	c0.185,2.126,0.405,4.384-0.07,6.42C348.545,235.919,345.965,237.665,343.447,237.842
	C337.917,237.939,345.965,237.665,343.447,237.842L343.447,237.842z"
      />
    </svg>
  );
};

export default Viber;
